
import KpiOsaService from './KpiOsaService';

export { default } from './KpiOsaService';
export const kpiOsaService = new KpiOsaService();
